import { Button, Input, InputProps, Typography } from '@libs/components';
import { useTranslation } from 'src/hooks';
import { useTheme } from 'styled-components';

import { CustomTypography, EditContent, EditInputWrapper } from './styles';

type EditItemNameModalContentProps = InputProps & {
  title: string;
  subTitle: string;
  image: React.ReactNode | React.ReactElement;
  onConfirm?: () => void;
  buttonTitle?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
};
const EditItemNameModalContent: React.FC<EditItemNameModalContentProps> = ({
  image,
  title,
  subTitle,
  onConfirm,
  buttonTitle,
  isDisabled,
  isLoading,
  ...inputProps
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  return (
    <>
      <EditContent>
        {image}
        <Typography type="caption" fontWeight={500} fontFamily="primaryMedium">
          {title}
        </Typography>
        <CustomTypography type="subHeadline" fontFamily="primaryBold">
          {subTitle}
        </CustomTypography>
      </EditContent>
      <EditInputWrapper>
        <Typography
          type="bodyButton"
          fontFamily="primaryMedium"
          color={colors.text.secondary}
        >
          {t('name_address')}
        </Typography>
        <Input {...inputProps} />
      </EditInputWrapper>
      <Button
        size="lg"
        onClick={onConfirm}
        title={buttonTitle}
        isLoading={isLoading}
        disabled={isDisabled}
      />
    </>
  );
};

export default EditItemNameModalContent;
